
<template>
  <div>
    <gateway-balance></gateway-balance>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    GatewayBalance: ()=> import('@/components/dashboards/GatewayBalance'),
  },
  data() {
    return {}
  },
  methods: {
    names() {
      
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>